module.exports = __webpack_public_path__ + "static/media/quotation-marks.74805cbc.svg";